import type { AppLanguage } from '@/shared/i18n/types';

import enFile from './en.json';
import jaFile from './ja.json';

const ja = (jaFile as { shopCoupon: any }).shopCoupon;
const en = (enFile as { shopCoupon: any }).shopCoupon;

export const shopCouponNamespaceResources: Record<AppLanguage, any> = {
  ja,
  en,
};